import styled from '@emotion/styled';
import { colors, Stack } from '@ui-components/neo.tax';

interface StyledLabelProps {
  $horizontal?: boolean;
}

export const StyledLabel = styled.label<StyledLabelProps>(
  {
    display: 'block',
    fontSize: '0.875rem', // text-sm equivalent
    fontWeight: 500, // font-medium equivalent
    color: colors.gray[700],
  },
  ({ $horizontal }) =>
    $horizontal
      ? {
          gridColumn: 'span 2 / span 2', // col-span-2 equivalent
        }
      : {},
);

export const StyledCapitalizationStatusStack = styled(Stack)({
  flex: 1,
});

export const StyledCapitalizationDatesStack = styled(Stack)({
  paddingLeft: 20,
  marginLeft: 8,
  height: 'fit-content',
  flex: 1,
});

// Holds the "Source / Auto-calculated" labeled cell in the left column. Mirrors the
// geometry of StyledCapitalizationStatusStack so Project Dates' Start/End columns sit at
// the same x position as Capitalization's.
export const StyledProjectDatesSpacerStack = styled(Stack)({
  flex: 1,
});

export const StyledProjectDatesStack = styled(Stack)({
  paddingLeft: 20,
  marginLeft: 8,
  flex: 1,
});

// Fixed-width cell for a single Start or End date column. Keeps "—" and "Mar 2026"
// the same width so Start/End positions align across Project Dates and Capitalization.
export const StyledDateCellStack = styled(Stack)({
  minWidth: 72,
});
